export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

export type Level = `${LogLevel}`;

export type LogParams<T extends Level> = Parameters<(typeof console)[T]>;

export interface LogPayload<TLogLevel extends Level = Level> {
  message: LogParams<TLogLevel>[0];
  level: TLogLevel;
  timestamp: string;
  context: string;
  metadata?: Record<string, unknown>;
  data?: LogParams<TLogLevel>[1];
}

export interface LoggerConfig {
  level?: LogLevel;
  enableConsole?: boolean;
}
